export const MAX_PRODUCT_IMAGE_SIZE = 2 * 1024 * 1024; // 2MB

export const PRODUCTS_LIMIT = 12;
export const GOODIE_LANDING_FALLBACK_COLOR = '#00bfff';